<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input class="form-control" type="text" v-model="block.header" :placeholder="$t('Header')" maxlength="200" />
    </div>

    <hr />

    <div class="mb-4">
      <label for="">{{ 'Style' | translate }}</label>
      <select v-model="color" class="form-select">
        <option value="">{{ 'Default' | translate }}</option>
        <option value="bg-dark">{{ 'Dark' | translate }}</option>
        <option value="bg-outline-dark">{{ 'Dark' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-primary">{{ 'Blue' | translate }}</option>
        <option value="bg-outline-primary">{{ 'Blue' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-secondary">{{ 'Grey' | translate }}</option>
        <option value="bg-outline-secondary">{{ 'Grey' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-light">{{ 'Light' | translate }}</option>
        <option value="bg-outline-light">{{ 'Light' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-info">{{ 'Cyan' | translate }}</option>
        <option value="bg-outline-info">{{ 'Cyan' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-warning">{{ 'Yellow' | translate }}</option>
        <option value="bg-outline-warning">{{ 'Yellow' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-danger">{{ 'Red' | translate }}</option>
        <option value="bg-outline-danger">{{ 'Red' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-success">{{ 'Green' | translate }}</option>
        <option value="bg-outline-success">{{ 'Green' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-indigo">{{ 'Indigo' | translate }}</option>
        <option value="bg-outline-indigo">{{ 'Indigo' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-pink">{{ 'Pink' | translate }}</option>
        <option value="bg-outline-pink">{{ 'Pink' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-purple">{{ 'Purple' | translate }}</option>
        <option value="bg-outline-purple">{{ 'Purple' | translate }} {{ 'outline' | translate }}</option>
        <option value="bg-teal">{{ 'Teal' | translate }}</option>
        <option value="bg-outline-teal">{{ 'Teal' | translate }} {{ 'outline' | translate }}</option>
      </select>
    </div>

    <draggable :list="items" handle=".grabbable">
      <div class="card mb-3" v-for="(item, index) in items" :key="index">
        <div class="card-header d-flex justify-content-between">
          <i class="fas fa-bars grabbable"></i>
          <button @click="deleteItem(index)" class="btn btn-outline-danger btn-sm">
            {{ 'Delete' | translate }}
          </button>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label>{{ 'Title' | translate }}</label>
            <input class="form-control" type="text" v-model="item.title" :placeholder="$t('Item')" />
          </div>
          <div class="mb-3">
            <label>{{ 'Description' | translate }}</label>
            <textarea
              class="form-control"
              v-model="item.description"
              :placeholder="$t('Item source')"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>
    </draggable>

    <div class="row">
      <div class="col">
        <button @click="addItem" class="btn btn-primary">
          {{ 'Add' | translate }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  props: ['block'],
  data() {
    return {
      items: this.block.data,
    }
  },
  updated() {
    this.updateBlock()
  },
  computed: {
    color: {
      get() {
        return this.block.settings?.color || ''
      },
      set(value) {
        const settings = this.block.settings || {}
        this.$set(this.block, 'settings', { ...settings, color: value })
      },
    },
  },
  methods: {
    deleteItem(key) {
      this.$delete(this.items, key)
    },
    addItem() {
      this.items.push({
        title: null,
        description: null,
      })
    },
    updateBlock() {
      this.block.data = this.items
    },
  },
}
</script>
